import { render } from "./NavBar.vue?vue&type=template&id=674cea9a&scoped=true&ts=true"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=674cea9a&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674cea9a"]])

export default __exports__